import {useContext, useEffect, useState} from "react";
import {FormControlLabel, Grid, Radio} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useRecoilState} from "recoil";
import {useForm} from "react-hook-form";
import {financialInfoState} from "../../../../../search-repair-shop/state";
import {GlobalContext} from "../../../../../../../util/state/GlobalContextProvider";
import {updateFinancialInfo} from "../../../../../search-repair-shop/rsSearch.actions";
import {SET_SNACKBAR} from "../../../../../common/utils";
import FormTextField from "../../../../../common/form-fields-wrappers/FormTextField";
import {FormRadioGroup} from "../../../../../common/form-fields-wrappers";
import TabWrapper from "../TabWrapper/TabWrapper";
import { FinancialInfoForm } from "./types";
import { setValuesInForm } from "../../../../constants";

const FinancialInfo = () => {
    const {t} = useTranslation(['network', 'translation']);
    const [financialInfo,setFinancialInfo] = useRecoilState(financialInfoState);
    const [open, setOpen] = useState(false);
    const {dispatchGlobalData} = useContext(GlobalContext);
    const financialInfoForm = useForm<FinancialInfoForm>({
        defaultValues: {
            id: financialInfo?.id ?? -1,
            feesDue: financialInfo?.feesDue === true ?  "Yes" : "No",
            representativeIdentificationCode: financialInfo?.representativeIdentificationCode ?? "",
            representativeAccountCode: financialInfo?.representativeAccountCode ?? "",
            clientIdentificationCode: financialInfo?.clientIdentificationCode ?? "",
            clientAccountCode: financialInfo?.clientAccountCode ?? "",
            acgIdentificationCode: financialInfo?.acgIdentificationCode ?? "",
        }
    });
    const onSubmit = (data: any) => {
        const reqParameters = {
            id: financialInfo?.id,
            feesDue: data.feesDue === "Yes",
            representativeIdentificationCode: data.representativeIdentificationCode,
            representativeAccountCode: data.representativeAccountCode,
            clientIdentificationCode: data.clientIdentificationCode,
            clientAccountCode: data.clientAccountCode,
            acgIdentificationCode: data.acgIdentificationCode,
        }
        setOpen(false);
        setFinancialInfo(financialInfo);
        updateFinancialInfo(reqParameters)
            .then((res:any) => {setFinancialInfo(res.financialInfo)})
            .catch(() => {dispatchGlobalData(SET_SNACKBAR.ERROR)});
    }

    useEffect(() => {
    if (!!financialInfo) {
        setValuesInForm(financialInfo, financialInfoForm, {feesDue: (cs) => cs ? 'Yes' : 'No'});
    }
    },[financialInfo])

    return (
        <TabWrapper infoForm={financialInfoForm} onSubmit={onSubmit} expanded={setOpen}>
            <>
                <Grid item xs={12} sm={6} md={3}>
                    <FormRadioGroup
                        control={financialInfoForm.control}
                        name="feesDue"
                        label={t("rsDetail.financialInfo.form.label.feesDue")}
                        disabled={!open}
                    >
                        <FormControlLabel
                            value="Yes"
                            control={<Radio/>}
                            label={t("rsDetail.financialInfo.form.label.yes")} />
                        <FormControlLabel
                            value="No"
                            control={<Radio />}
                            label={t("rsDetail.financialInfo.form.label.no")}
                        />
                    </FormRadioGroup>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled
                        control={financialInfoForm.control}
                        name="representativeIdentificationCode"
                        label={t("rsDetail.financialInfo.form.label.representativeIdentificationCode")}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled={!open}
                        control={financialInfoForm.control}
                        name="representativeAccountCode"
                        label={t("rsDetail.financialInfo.form.label.representativeAccountCode")}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled={!open}
                        control={financialInfoForm.control}
                        name="clientIdentificationCode"
                        label={t("rsDetail.financialInfo.form.label.clientIdentificationCode")}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled={!open}
                        control={financialInfoForm.control}
                        name="clientAccountCode"
                        label={t("rsDetail.financialInfo.form.label.clientAccountCode")}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormTextField
                        disabled={!open}
                        control={financialInfoForm.control}
                        name="acgIdentificationCode"
                        label={t("rsDetail.financialInfo.form.label.acgIdentificationCode")}
                    />
                </Grid>
            </>
        </TabWrapper>
    )
}

export default FinancialInfo;
